import { render, staticRenderFns } from "./ccInputTags.vue?vue&type=template&id=2b719ff4"
import script from "./ccInputTags.vue?vue&type=script&lang=js"
export * from "./ccInputTags.vue?vue&type=script&lang=js"
import style0 from "./ccInputTags.vue?vue&type=style&index=0&id=2b719ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports